export * from './new-configuration.class';
export * from './new-configuration.model';